import React from "react";
import SwitchElementProperties from './SwitchElementProperties';
import { isSet } from "../../../../Utils/CommonFunctions";
import Icons from "../../../Icons/Icons";

const ElementsProperties = (props)=>{
    


    const {currentElement} = props;
        let currentElementData = isSet(currentElement.data,{});
        
        const toggledClass = (isSet(currentElement.id,null)!=null && isSet(currentElement.id,'').indexOf('body') == -1)?'toogled':'';
        // try{
        //     if(currentElement.id!=''){
        //         currentElementData =  eval('htmlContentItems'+currentElement.map);
        //     }
            
            
        // }catch(e){

        // }
    return(
        <div id="sidebar-wrapper1" style={{'zIndex':(toggledClass==='toogled')?'9999':'0',left:'0',top:'0',width:(toggledClass==='toogled')?'350px':'0px'}} className={"forFilter border-left forBuilderBox "+toggledClass}>
			<div className="filter_Box">
				<div className="filter_Header p-2 bg-white">
                    <div className="d-flex align-items-center justify-content-between">
				             	<label className="form-label"> {isSet(currentElementData.label,'')} Properties </label>
					            <button type="button" className="btn btn-sm btn-icon btn-active-light-primary" id="builerDetailsOff" onClick={()=>props.setSelectedCurrentId('')}>
					               <span className="svg-icon svg-icon-1">
                                      <Icons iconType={'Close2'} />
					               </span>
					            </button>
				         	</div>
                </div>
                    <div className="filter_Body p-3">
                    {isSet(currentElementData.properties,[]).map((item,itemIndex)=>{
                        return(
                            <div className="form-group">
                                <label className="form-label">{item.label}</label>
                                <div>
                                <SwitchElementProperties
                                    elementData={currentElementData}
                                    changeHandler={props.onChangePropertiesHandler}
                                    // onChangeHandler={(key,val)=>onChangePropertiesHandler(key,val)} 
                                    {...item} 
                                    uploadFileRef={props.uploadFileRef}
                                    fileChangeHandler={props.fileChangeHandler}
                                    fileClickHandler={props.fileClickHandler}
                                    isFrom='Layout'
                                    showFilterContent={props.showFilterContent} 
                                />
                                </div>
                            </div>
                        )
                    })}
                    </div>
            </div>
        </div>
    )
}

export default ElementsProperties;